import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent {
  @Input() searchTerm: string = '';
  @Input() labelSearch: String = 'Tìm kiếm'
  // Emit the search term to the parent component
  @Output() searchChange: EventEmitter<string> = new EventEmitter<string>();

  onSearchChange(): void {
    this.searchChange.emit(this.searchTerm);
  }
}
